module.exports = __webpack_public_path__ + "img/bd.c4a1485f.svg";